/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who1_TitleInputs */

const en_dr_who1_title = /** @type {(inputs: Dr_Who1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams & founders`)
};

const id_dr_who1_title = /** @type {(inputs: Dr_Who1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim & founder`)
};

/**
* | output |
* | --- |
* | "Teams & founders" |
*
* @param {Dr_Who1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who1_title = /** @type {((inputs?: Dr_Who1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who1_title(inputs)
	return en_dr_who1_title(inputs)
});